export default "__VITE_ASSET__1LNvDlJe__"